
    import '/opt/buildhome/repo/docs/playground/copilot.zh-CN.md?watch=parent';
    export const toc = [{"id":"docs-playground-copilot-demo-copilot","depth":3,"title":"助手式"}];
export const frontmatter = {"title":"助手式","toc":"menu","filename":"docs/playground/copilot.zh-CN.md","lastUpdated":1759242449000,"group":{"title":"模型样板间","order":0},"order":1,"__autoDescription":true};